<mat-nav-list>
  <mat-list-item (click)="navigate(null, '/dashboard')">
    {{ 'CORE.MENU.DASHBOARD' | translate }}
  </mat-list-item>
  <div *ngxPermissionsOnly="['COMMERCIAL']">
    <mat-list-item (click)="navigate('commercial', '/deal/search')">
      {{ 'CORE.MENU.COMMERCIAL.DEAL' | translate }}
    </mat-list-item>
    <mat-list-item (click)="navigate('commercial', '/work-record/search')"
                   routerLinkActive="{{theme}}-theme-active-link">
      {{ 'CORE.MENU.COMMERCIAL.WORK_RECORD' | translate }}
    </mat-list-item>

    <mat-list-item (click)="navigate('commercial', '/work-record/vod-search')"
                   routerLinkActive="{{theme}}-theme-active-link">
      {{ 'CORE.MENU.COMMERCIAL.VOD_SEARCH' | translate }}
    </mat-list-item>
    <mat-list-item *ngxPermissionsOnly="['ACCOUNTANT', 'ADMINISTRATIVE_CONTROLLER']"
                   (click)="navigate('commercial', '/accounting-closing/consult')"
                   routerLinkActive="{{theme}}-theme-active-link">
      {{ 'CORE.MENU.COMMERCIAL.ACCOUNTING_CLOSING' | translate }}
    </mat-list-item>
    <mat-list-item (click)="navigate('commercial', '/invoice/search')"
                   routerLinkActive="{{theme}}-theme-active-link">
      {{ 'CORE.MENU.COMMERCIAL.INVOICE' | translate }}
    </mat-list-item>
    <mat-list-item *ngxPermissionsOnly="['ACCOUNTANT', 'ADMINISTRATIVE_CONTROLLER']"
                   (click)="navigate('commercial', '/turnover/search')"
                   routerLinkActive="{{theme}}-theme-active-link">
      {{ 'CORE.MENU.COMMERCIAL.TURNOVER' | translate }}
    </mat-list-item>
  </div>
  <mat-list-item *ngIf="user.admin" (click)="navigate('user', '/account/authorization/search')"
                 routerLinkActive="{{theme}}-theme-active-link">
    {{ 'CORE.MENU.USER.SECTION_TITLE' | translate }}
  </mat-list-item>
  <mat-list-item *ngxPermissionsOnly="['MODULE REF']" (click)="navigate('referential', '/support/list')"
                 routerLinkActive="{{theme}}-theme-active-link">
    {{ 'CORE.MENU.REFERENTIAL.SUPPORT' | translate }}
  </mat-list-item>
  <mat-list-item (click)="navigate('user', '/account/settings')"
                 routerLinkActive="{{theme}}-theme-active-link">
    {{ 'CORE.MENU.USER.SETTINGS.LABEL' | translate }}
  </mat-list-item>
  <mat-list-item *ngxPermissionsOnly="['MODULE REF']" (click)="navigate('batch', '/jobs/referential')"
                 routerLinkActive="{{theme}}-theme-active-link">
    {{ 'CORE.MENU.REFERENTIAL.BATCH' | translate }}
  </mat-list-item>
  <mat-list-item *ngxPermissionsOnly="['TVDATA']" (click)="navigate('tvdata', '/infos-center')"
                 routerLinkActive="{{theme}}-theme-active-link">
    {{ 'CORE.MENU.TV-DATA' | translate }}
  </mat-list-item>
  <mat-list-item *ngxPermissionsExcept="['UNIVERSAL_ROLE']" (click)="navigate('expenditure-commitment', '/home/commands')"
                 routerLinkActive="{{theme}}-theme-active-link">
    {{ 'CORE.MENU.EXPENDITURE_COMMITMENT' | translate }}
  </mat-list-item>
  <mat-list-item *ngxPermissionsOnly="['MODULE BI']" (click)="navigate('bi', '/simple-search/form')"
                 routerLinkActive="{{theme}}-theme-active-link">
    {{ 'CORE.MENU.BI.SEARCH' | translate }}
  </mat-list-item>

  <mat-list-item *ngxPermissionsOnly="['LEGAL']" (click)="navigate('legal', '/contracts/menu/legals-det')"
                 routerLinkActive="{{theme}}-theme-active-link">
    {{ 'CORE.MENU.LEGAL.LEGAL' | translate }}
  </mat-list-item>

</mat-nav-list>

